import $ from 'jquery';

// helper method to visually check width of text in question by measuring width in a hidden,
// offscreen text container
export function measureTextWidth(text) {
  let testcontainer = $('.form-field-measure-container'); // eslint-disable-line ember/no-jquery
  if (testcontainer.length === 0) {
    testcontainer = $('<p class="form-field-measure-container"></p>'); // eslint-disable-line ember/no-jquery
    $('body').append(testcontainer); // eslint-disable-line ember/no-jquery
  }
  testcontainer.text(text);
  return testcontainer.width();
}